import { Injectable } from '@angular/core';
import { PaginatedItems } from '../../models/types';
import { BaseService } from '../../services/_base.service';
import { catchError, Observable, throwError } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { FinancialMovement } from './financial-movement.model';


export interface IFilter {
  allocated: boolean;
  created_at_start: string;
  created_at_end: string;
  due_date_start: string;
  due_date_end: string;
  query: string;
  paid: boolean;
  total_start: number;
  total_end: number;
  type: string;
}

interface SearchParamsType {
  query: string | number;
}

export interface SearchResponseType {
  items: FinancialMovement[];
}

export interface FinancialMovementsStatistics {
  margin: number,
  incomes: number,
  expenses: number,
}

interface IndexResponseType extends PaginatedItems<FinancialMovement> {
  statistics: FinancialMovementsStatistics;
}

@Injectable({
  providedIn: 'root'
})
export class FinancialMovementService extends BaseService {

  index(
    pageIndex: number = 1,
    pageSize: number = 10,
    filters: Partial<IFilter>,
    sort: string,
  ): Observable<HttpResponse<IndexResponseType>> {
    return this.http.get<IndexResponseType>(
      `${this.apiURL}/financial_movements`,
      this.getOptions(
        {
          page: pageIndex,
          page_size: pageSize,
          ...filters,
          sort,
        },
      ),
    );
  }

  create(financial_movement: Partial<FinancialMovement>): Observable<HttpResponse<FinancialMovement>> {
    return this.http.post<FinancialMovement>(`${this.apiURL}/financial_movements`, { financial_movement }, this.getOptions()).pipe(
      catchError((error) => {
        console.error(error);
        return throwError(() => error);
      })
    );
  }
  
  get(id: number): Observable<HttpResponse<FinancialMovement>> {
    return this.http.get<FinancialMovement>(`${this.apiURL}/financial_movements/${id}`, this.getOptions()).pipe(
      catchError((error) => {
        console.error(error);
        return throwError(() => error);
      })
    );
  }

  update(id: number, financial_movement: Partial<FinancialMovement>): Observable<HttpResponse<FinancialMovement>> {
    return this.http.put<FinancialMovement>(`${this.apiURL}/financial_movements/${id}`, { financial_movement }, this.getOptions()).pipe(
      catchError((error) => {
        console.error(error);
        return throwError(() => error);
      })
    );
  }

  search(params: SearchParamsType) {
    return this.http.get<SearchResponseType>(
      `${this.apiURL}/financial_movements/search`,
      this.getParams({
        search: params.query,
      }),
    );
  }

  delete(id: number) {
    return this.http.delete(`${this.apiURL}/financial_movements/${id}`, this.getOptions())
      .pipe(
        catchError((error) => {
          console.error(error);
          return throwError(() => error);
        }),
      );
  }
}
